import { Decimal } from 'decimal.js';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCentsToDollars(cents: number) {
  const dollars = new Decimal(cents).div(100);
  if (cents % 100 === 0) {
    return dollars.toFixed(0);
  } else {
    return dollars
      .toFixed(2)
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }
}

export function serializeStringToSlug(str: string) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

export function deserializeSlugToString(slug: string) {
  return slug.replace(/-/g, ' ');
}
